import React, { useState, useEffect } from 'react';
import { useMediaQuery } from '@podiumhq/design-system';

import { useBusinessInfoContext } from 'contexts/BusinessContextProvider';
import { useNotificationContext } from 'contexts/NotificationContextProvider';
import { useTrialsContext } from 'contexts/TrialsContextProvider';
import useChangePage from 'hooks/useChangePage';
import { TRIAL_URL } from 'routes/constants';

import AccountError from '../../components/AccountError';
import useSubmitCreateTrial from '../../hooks/useSubmitCreateTrial';
import { FakeWrapper } from '../../layout';

import CreatingBusinessNumber from './CreatingBusinessNumber';

const TrialSubmitLoadingState = () => {
  const { validateBusinessName, validateBusinessInfo } =
    useBusinessInfoContext() || {};
  const changePage = useChangePage();
  const { shouldDisplay, setShouldDisplay } = useNotificationContext() || {};
  const { createNewTrialNoCreditCard } = useSubmitCreateTrial();
  const { hasValidLogin, hasValidName, accountExists } =
    useTrialsContext() || {};

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSmallerThan650px] = useMediaQuery('(max-width: 650px)');

  const handleSubmit = () => {
    const hasValidBusinessName = validateBusinessName(true);

    if (!hasValidBusinessName) return;

    setShouldDisplay(false);
    setIsSubmitting(true);
    const hasValidBusinessGmb = validateBusinessInfo({ displayErrors: false });

    createNewTrialNoCreditCard(hasValidBusinessGmb).then(
      // the response & error handling is done in the create above
      // & if successful will redirect to onboarding
      () => setIsSubmitting(false)
    );
  };

  useEffect(() => {
    const validAccount = hasValidLogin();
    const validName = hasValidName();
    if (accountExists || !validAccount || !validName) {
      return changePage(TRIAL_URL, true);
    } else {
      handleSubmit();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FakeWrapper showIcon={false} padding={isSmallerThan650px ? '0px' : '24px'}>
      {shouldDisplay ? (
        <AccountError handleSubmit={handleSubmit} isSubmitting={isSubmitting} />
      ) : (
        <CreatingBusinessNumber />
      )}
    </FakeWrapper>
  );
};

export default TrialSubmitLoadingState;
